import { Component } from '@angular/core';
import { LoadingController } from 'ionic-angular';
import { AppState } from '../../../../app/app.global';
import { HttpService } from '../../../../providers/service/httpservice';
import { HISCARDLIST,CARDFEE} from '../../../../providers/config/serviceurl';
import { StorageService } from '../../../../providers/service/storageservice';

@Component({
  selector: 'cardquery',
  templateUrl: 'cardquery.html'
})

export class CardQueryPage {
	
	consumptionList:any=[];
	user:any={};
	pageIndex = 0;
	fee:string="";
	constructor(private loadCtrl:LoadingController,public global: AppState,private httpService:HttpService) {
		this.user = StorageService.getObj('currentUser');
    this.consumptionList = StorageService.getObj('consumptionList');
    this.fee =  StorageService.getObj('cardfee');
    this.getYktList();
    this.getFee();
	}
	
	//查询卡内余额
  getFee(){
  	var params = {'yktno':this.user.snnuid};
  	this.httpService.post(CARDFEE,params).then(anyObj =>this.handleFeeList(anyObj));
  }
  
  handleFeeList(obj:any){
  	if(obj){
			this.fee = obj;
  		StorageService.setObj("cardfee",this.fee);
  	}
  }
	//查询一卡通消费信息
  getYktList(){
  	var params = {'yktno':this.user.snnuid};
  	this.httpService.post(HISCARDLIST,params).then(anyObj =>this.handleYktList(anyObj));
  }
  
  handleYktList(obj:any){
  	if(obj){
			this.consumptionList = obj.data;
  		StorageService.setObj("consumptionList",this.consumptionList);
  	}
  }
	
	loadMore(refresher){
		setTimeout(() => {
      refresher.complete();
    }, 1000);
	}
	
	
}


// WEBPACK FOOTER //
// ./src/pages/application/life/card/cardquery.ts